/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ShieldUserIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAByElEQVR4nLVUTUscQRBtT3pZRWNOguBVJCTnYJZ4Gpjpqhqlp2oMYX+GBLyJv0bdgyJ60JOC/oS9CKIek4tEvJlQ6wyra8/szu5a8GDoeVWvvrqNqWBRlM4qqvj0F5jSOiCfAslTG8inejZ0YLuafAWUAyD55wXKOWJqRx+YBhQKnPtoiY/7Dkyvob6lMwLiXb+j3ESYrgFATRFhSpakVSCyUyIgD77gzrmZbm4Yrk/rP4/IQ5nAm4wiTNcK+TE7n08lAQCoFfGD4Mfkuwo456YqCViSe0+LqISfvF1ZfiyuAPnaM+SWDrSbS/Tzg0W+9QhclVTAh0VrCjE77blCM/cGfxY4Kq6AZHPQSwadZH4VC4Bb7M7cIm8h8rK2xBgzptDbCpB8A5JtILl76RPGyVKhQNamy+xG7gdBMF5KNsbUG40J5eZvUi++sbGsPGfDf611C734UeTm8+2zsQQ9BbIqsoz4TDMsy145ecWmX2u/qtmWWOKmr1V6Bih7+azUx1QxAPlikX9nvb0IQzeX/9NvPWsHR/mjXDOIIa5/7lQi9xZ5o42858i31sonM4yR3ljipufdb2arOxoDSL4DyYlCN21kgYe1/xfkwY9qM6OQAAAAAElFTkSuQmCC)
 */
export const ShieldUserIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M3.47 5.18c.27-.4.64-.74 1.1-.96l6.09-3.05a3 3 0 0 1 2.68 0l6.1 3.05A2.83 2.83 0 0 1 21 6.75v3.5a14.17 14.17 0 0 1-8.42 12.5c-.37.16-.79.16-1.16 0A14.18 14.18 0 0 1 3 9.77V6.75c0-.57.17-1.11.47-1.57Zm2.95 10.3A12.18 12.18 0 0 0 12 20.82a12.18 12.18 0 0 0 5.58-5.32A9.49 9.49 0 0 0 12.47 14h-.94c-1.88 0-3.63.55-5.11 1.49ZM12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
